/* eslint no-param-reassign:
  ["error", {
    "props": true,
    "ignorePropertyModificationsFor": ["state"]
  }
] */
import pageableFactory from './mixins/pageable';
import crudableFactory from './mixins/crudable';

const pageable = pageableFactory();
const crudable = crudableFactory();

const subaccountsModule = {
  namespaced: true,
  state: {
    ...pageable.state,
    ...crudable.state,
  },
  mutations: {
    ...pageable.mutations,
    ...crudable.mutations,
  },
  actions: {
    CREATE: crudable.actions.createPartialApplication({
      uriRoot: 'partners/subaccounts',
      name: 'account',
      props: {
        name: 'name',
        email: 'email',
        account_email: 'account_email',
      },
      isSingular: true,
    }),
    PAGINATE: pageable.actions.paginatePartialApplication({
      url: 'partners/subaccounts',
    }),
  },
  getters: {
    ...pageable.getters,
    get: state => envelopeId => state.results.filter(item => item.id === envelopeId)[0],
  },
};

export default subaccountsModule;
